import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { ReactComponent as CartIcon } from '../../svg/cart.svg';
 
const ButtonCart = ({onClick}) => {
  return (
    <Stack spacing={2} direction="row">
        <Button onClick={onClick} variant="contained">ADD<CartIcon/></Button>
    </Stack>
  );
}

export default ButtonCart;